const getters = {

    getCompanies: state => state.companies,
    getUsersFromCompany : state => state.users,
}

export default getters